import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSalary, getVisas, verifyDate } from "../../services/salaryService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table, Button, Message } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEntrySubTypes } from "../../services/generalLedgerService";

class SalaryForm extends Component {
  state = {
    salaryDate: new Date(),
    visas: [],
    showSalaryForm: false,
    showError: false,
    projects: [],
  };

  handleChangeSalaryDate = (date) => {
    this.setState({
      salaryDate: date,
    });
  };

  async componentDidMount() {
    const { data: visas } = await getVisas();
    this.setState({ blocking: false, visas });
    this.loadProjects();
  }

  async loadProjects() {
    this.setState({ blocking: true });
    let params = {
      company: 1,
      entryType: "project",
    };
    const { data: res } = await getEntrySubTypes(params);

    this.setState({ blocking: false, projects: res.accounts });
  }

  doSubmit = async () => {
    try {
      var event = new Date(this.state.salaryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      this.setState({ blocking: true });
      const verifyData = { date: date };
      const res = await verifyDate(verifyData);
      if (res.data.proceed == "no") {
        this.setState({
          showError: true,
          showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          showSalaryForm: true,
          blocking: false,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  confirmSalary = async (visaId) => {
    this.setState({ blocking: true });
    const hour = document.getElementById(visaId).value;
    const rate = document.getElementById("rate_" + visaId).value;
    const projectId = document.getElementById("pro").value;

    if (hour == "") {
      toast.warning("Please select hour to continue.");
      this.setState({ blocking: false });
      return false;
    }

    // if (projectId == "") {
    //   toast.warning("Please select project to continue.");
    //   this.setState({ blocking: false });
    //   return false;
    // }

    var event = new Date(this.state.salaryDate);
    let date = JSON.stringify(event);
    date = date.slice(1, 11);

    const verifyData = {
      visaId: visaId,
      hour: hour,
      rate: rate != "" ? rate : 12, //12 AED fixed if rate not provided
      salary_date: date,
      project_id: parseInt(projectId),
    };
    try {
      await saveSalary(verifyData);
      toast.success("Entry has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        toast.warning("Hours should be only numbers");
      }
    }

    this.setState({ blocking: false });
  };

  projectUpdate = () => {
    this.state.visas.map(
      (visa) => (document.getElementById(visa.id).value = "")
    );
  };

  render() {
    if (
      auth.getCurrentUser().role != "salary-admin" &&
      auth.getCurrentUser().role != "client"
    ) {
      return "Your are authorized to perform this action.";
    }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add salary</h1>

        <div className="grid add-salary-filters">
          <DatePicker
            selected={this.state.salaryDate}
            onChange={this.handleChangeSalaryDate}
            placeholderText="Select Salary Date"
            className="input"
          />
          <div></div>
          <select
            id="pro"
            onClick={() => this.projectUpdate()}
            className="input"
          >
            <option value="">Select project</option>
            {this.state.projects.map((project) => (
              <option value={project.id}>{project.name}</option>
            ))}
          </select>
          <div></div>

          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <center>
          <div className="ui error form" style={{ width: "30%" }}>
            <Message
              negative
              style={{
                display: this.state.showError == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Date is not valid or salary already entered.</p>
            </Message>
          </div>

          <div
            className="scrap-report"
            style={{
              display: this.state.showSalaryForm == true ? "block" : "none",
            }}
          >
            <Table celled fixed singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={1}>Id</Table.HeaderCell>
                  <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Mobile</Table.HeaderCell>
                  <Table.HeaderCell width={3}>Company</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Rate</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Hours</Table.HeaderCell>
                  <Table.HeaderCell width={2}></Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {this.state.visas.map((visa) => (
                  <Table.Row key={visa.id}>
                    <Table.Cell>{visa.id}</Table.Cell>
                    <Table.Cell style={{ whiteSpace: "pre-line" }}>
                      {visa.name}
                    </Table.Cell>
                    <Table.Cell>{visa.mobile}</Table.Cell>
                    <Table.Cell>{visa.company}</Table.Cell>
                    <Table.Cell>
                      <input
                        maxlength="4"
                        className="input"
                        type="text"
                        id={"rate_" + visa.id}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <input
                        maxlength="4"
                        className="input"
                        type="text"
                        id={visa.id}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <button
                        className="btn btn--accent"
                        onClick={() => this.confirmSalary(visa.id)}
                      >
                        Confirm
                      </button>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default SalaryForm;
